// extracted by mini-css-extract-plugin
module.exports = {"studentActivityLog":"StudentActivityLog_studentActivityLog__VcJKd","logHeader":"StudentActivityLog_logHeader__1G9Ys"};